'use strict';

var offerapp = angular.module("offerapp", []);

offerapp.factory('httpRequestInterceptor', function () {
    return {
        request: function (config) {
            if (config.url.indexOf("/api/") === 0) {
                if (window.current_location != null) {
                    config.headers['current-location'] = window.current_location;
                } else {
                    GetCurrentUserLocation(function(coordinates) {
                        config.headers['current-location'] = window.current_location;
                    });
                }
            }
            return config;
        }
    };
});

offerapp.config(function ($locationProvider, $httpProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });
    $httpProvider.interceptors.push('httpRequestInterceptor');
});

(function() {
    'use strict';

    offerapp.service("dataService", dataService);
    dataService.$inject = ['$http', '$q'];

    offerapp.directive("rating", function () {
        return {
            templateUrl: "rating.html",
            restrict: 'A',
            replace: true,
            scope: {                
                ratingValue: '@rating'
            }
        };
    });

    offerapp.directive("mobileImageList", function () {
        return {
            templateUrl: "mobileImageList.html",
            restrict: 'A',
            replace: true,
            scope: {

                ratingValue: '@rating',
            }
        };
    });

    offerapp.directive("canBeSvg", externalSvg);
    function externalSvg() {
        return {
            restrict: 'C',
            link: link
        };

        function link($scope, elm, attrs) {            
            $(elm).load(function () {
                if (!attrs.src.endsWith("svg")) {
                    return;
                }
                $(elm).hide();

                var xhr = new XMLHttpRequest();
                xhr.open("GET", attrs.src);
                xhr.overrideMimeType("image/svg+xml");
                xhr.addEventListener('load',
                    function (e) {                        
                        var container = $("<span>");
                        container.append(xhr.responseXML.documentElement);
                        $(elm).after(container);
                    });
                xhr.send("");                
            }); 
            
        }
    }    

    offerapp.filter("trust", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        }
    }]);

    offerapp.controller("offerCtrl", offerCtrl);
    offerCtrl.$inject = ['dataService', '$timeout', '$window'];

    function offerCtrl(dataService, $timeout, $window) {
        var vm = this;
        vm.noOffer = false;
        vm.offerID = $(".offer[data-id]").data("id");
        vm.locationID = $(".offer[data-locationid]").data("locationid");
        vm.distance = distance;
        vm.getOfferReviews = getOfferReviews;
        vm.getOfferHistory = getOfferHistory;
        vm.dateToString = dateToString;
        vm.dateTimeToString = dateTimeToString;
        vm.getGoogleLink = getGoogleLink;
        vm.showRedeemModal = showRedeemModal;
        vm.displayOfferBox = displayOfferBox;
        vm.displayOtherLocations = displayOtherLocations;
        vm.isMobile = isMobile;
        vm.addToFavourites = addToFavourites;
        vm.removeFromFavourites = removeFromFavourites;

        init();

        function getGoogleLink(location) {
            if (location == null) {
                return "";
            }
            return "http://maps.google.com/?q=" + location.Address + "," + location.Suburb + "," + location.State + "," + location.Postcode;
        }

        function showRedeemModal() {
            $(".offers-modal").modal();
        }

        function dateToString(value) {
            return moment(value).format("Do MMM YYYY");
        }

        function dateTimeToString(value) {
            return moment(value).format("Do MMM YYYY, h:mm A");
        }        

        function distance(currentlat, currentlog, lat, long) {
            currentlat = currentlat || null;
            currentlog = currentlog || null;
            var d = getDistanceFromLatLonInKm(currentlat, currentlog, lat, long);
            return d.toFixed(0).toString() + "km";
        }

        function getOfferReviews(e, id) {
            var button = e.currentTarget;            
            var isLoaded = $(button).data("isloaded");
            if (!isLoaded) {
                var target = $(button).data("updatedtarget");

                dataService.getOfferReviews(id).then(function(res) {
                    vm.reviews = res.data.Data;
                    $(button).data("isloaded", "true");
                    $(target).show();
                });                
            }
        }

        function getOfferHistory(e, id) {
            var button = e.currentTarget;
            console.log(button);
            var isLoaded = $(button).data("isloaded");
            if (!isLoaded) {
                var target = $(button).data("updatedtarget");

                dataService.getOfferRedemptionHistory(id).then(function (res) {
                    vm.histories = res.data.Data;
                    $(button).data("isloaded", "true");
                    $(target).show();
                });
            }
        }

        function recalculteDistance() {
            if (vm.UserCurrentLocation != null) {
                if (vm.data != null) {
                    vm.data.distance = distance(vm.UserCurrentLocation.Latitude, vm.UserCurrentLocation.Longitude,
                        vm.data.ContextLocation.Latitude, vm.data.ContextLocation.Longitude);

                    vm.data.Merchant.Locations.forEach(function(location) {
                        location.distance = distance(vm.UserCurrentLocation.Latitude, vm.UserCurrentLocation.Longitude,
                            location.Latitude, location.Longitude);
                    });
                }
            }
        }


        function loadOffer(q) {
            var req = dataService.getOffer(vm.offerID, vm.locationID);
            handlePendingRequests(vm, "getOffer", req);

            req.promise.then(function (res) {
            
                $(".offer").parent().show();
                if (res.data.Status !== 200) {
                    vm.noOffer = true;
                    return;
                }
                vm.noOffer = false;

                vm.data = res.data.Data;
                recalculteDistance();

                $timeout(function () {
                    if ($(".royalSlider img").size() > 0) {
                        $(".royalSlider")
                            .royalSlider({
                                keyboardNavEnabled: true,
                                arrowsNav: false,
                                controlNavigation: 'bullets',
                                autoHeight: true,
                                imageScaleMode: 'fill',
                                transitionType: 'fade',
                                autoPlay: {
                                    enabled: true,
                                    pauseOnHover: true,
                                    delay: 5000
                                }
                            });
                    }
                    var slider = $('.royalSlider'),
                        nav = slider.find('.rsNav');
                    if (slider.data('royalSlider') != null && slider.data('royalSlider').numSlides <= 1) {
                        nav.hide();
                    }
                });
            });
        }

        function loadCurrentUserLocation() {
            GetCurrentUserLocation(function (loc) {
                if (loc != null) {
                    var sp = loc.split(',');
                    vm.UserCurrentLocation = {
                        Latitude: parseFloat(sp[0]),
                        Longitude: parseFloat(sp[1])
                    };
                    loadOffer();
                }
            });
        }

        function init() {
            loadCurrentUserLocation();
            //wait if we can got user current location
            $timeout(function () {
                if (vm.UserCurrentLocation == null) {
                    loadOffer();
                }
            }, 200);

            $window.onfocus = function() {
                $timeout(function() {
                    if (vm.UserCurrentLocation == null) {
                        loadCurrentUserLocation();
                    }

                }, 200);
            };
        }

        function displayOfferBox() {
            return $(".location--lead").text().trim() !== "";
        }

        function displayOtherLocations() {
            if (vm.data == null) {
                return false;
            }
            var hasMore = vm.data.Merchant.Locations.length > 1;
            var hasAnyAddress = false;
            vm.data.Merchant.Locations.forEach(function(l, i) {
                if (l.DisplayType !== 'None' && i > 0) {
                    hasAnyAddress = true;
                }
            });
            return hasMore && hasAnyAddress;
        }

        function isMobile() {
            return $(".navbar-header .navbar-toggle").is(":visible");
        }

        function addToFavourites() {
            dataService.addToFavourites(vm.data.Merchant.ID).then(function (res) {
                vm.data.IsMyFavourite = true;
            });
        }

        function removeFromFavourites() {
            dataService.removeFromFavourites(vm.data.Merchant.ID).then(function (res) {
                vm.data.IsMyFavourite = false;
            });
        }
    };
})();

